import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import Accordion, {
  AccordionItem,
  AccordionItemHeader,
  AccordionItemPanel,
} from 'src/components/common/Accordion';
import OrgTree from 'src/components/common/OrgTree';
import useOrgTreeState from 'src/components/common/OrgTree/hooks/useOrgTreeState';
import { CHECKBOX_MODE } from 'src/components/common/OrgTree/types';
import { ORG_UNIT_CUSTOM_ORG_TREE_TEST_ID } from 'src/components/report/OrgUnitReportsPage';

import DateFilter from './DateFilter/DateFilter';
import type { FilterSections } from './FilterColumn';
import FilterColumn from './FilterColumn';

interface SidebarProps {
  filterColumnSections?: FilterSections;
  noFilterColumn?: boolean;
}

const Sidebar: FC<SidebarProps> = ({
  filterColumnSections,
  noFilterColumn,
}) => {
  const { t } = useTranslation('followUp');
  const orgTreeState = useOrgTreeState();

  return (
    <>
      <DateFilter />
      <Accordion
        initiallyActiveItems={[
          noFilterColumn
            ? 'org-tree-accordion-item'
            : 'table-filter-accordion-item',
        ]}
      >
        <AccordionItem
          itemName="org-tree-accordion-item"
          aria-label={t('OrgTree')}
        >
          <AccordionItemHeader headline={t('OrgTree')} />

          <AccordionItemPanel data-test-id={ORG_UNIT_CUSTOM_ORG_TREE_TEST_ID}>
            <OrgTree
              orgTreeState={orgTreeState}
              itemsAreDraggable={false}
              checkboxMode={CHECKBOX_MODE.MULTI}
            />
          </AccordionItemPanel>
        </AccordionItem>
        {!noFilterColumn && (
          <AccordionItem itemName="table-filter-accordion-item">
            <AccordionItemHeader headline={t('filter.ticketFilter')} />
            <AccordionItemPanel>
              <FilterColumn {...filterColumnSections} survey={false} />
            </AccordionItemPanel>
          </AccordionItem>
        )}
      </Accordion>
    </>
  );
};

export default Sidebar;
